import Embla, { EmblaOptionsType, EmblaCarouselType } from "embla-carousel";
// import { setupDotBtns, generateDotBtns, selectDotBtn } from "./carousel-dots";

const OPTIONS: EmblaOptionsType = {};
const OPTIONS_THUMBS: EmblaOptionsType = {
  containScroll: "keepSnaps",
  // dragFree: true,
};

const emblaCardsContributors = document.querySelector(
  ".card-contributors-carousel"
) as HTMLElement;
const emblaCardsArticles = document.querySelector(
  ".card-articles-carousel"
) as HTMLElement;

const viewportNodeMainCarousel =
  document.querySelector<HTMLElement>(".embla__viewport");
const viewportNodeThumbCarousel = document.querySelector<HTMLElement>(
  ".embla-thumbs__viewport"
);

const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
  prevBtn.addEventListener("click", embla.scrollPrev, false);
  nextBtn.addEventListener("click", embla.scrollNext, false);
};

const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
  return () => {
    if (embla.canScrollPrev()) prevBtn.removeAttribute("disabled");
    else prevBtn.setAttribute("disabled", "disabled");

    if (embla.canScrollNext()) nextBtn.removeAttribute("disabled");
    else nextBtn.setAttribute("disabled", "disabled");
  };
};

// Thumbs

const addThumbBtnsClickHandlers = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): (() => void) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map((_, index) => (): void => {
    if (emblaApiThumb.clickAllowed()) emblaApiMain.scrollTo(index);
  });

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });

  return (): void => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener("click", scrollToIndex[index], false);
    });
  };
};

const addToggleThumbBtnsActive = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): (() => void) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = (): void => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
    slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
  };

  emblaApiMain.on("select", toggleThumbBtnsState);
  emblaApiThumb.on("init", toggleThumbBtnsState);

  const prevBtn = viewportNodeThumbCarousel.querySelector(
    ".embla__button--prev"
  );
  const nextBtn = viewportNodeThumbCarousel.querySelector(
    ".embla__button--next"
  );

  setupPrevNextBtns(prevBtn, nextBtn, emblaApiMain);

  const disablePrevAndNextBtns = disablePrevNextBtns(
    prevBtn,
    nextBtn,
    emblaApiMain
  );
  emblaApiMain.on("select", disablePrevAndNextBtns);
  emblaApiMain.on("init", disablePrevAndNextBtns);

  return (): void => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
  };
};

if (emblaCardsContributors) {
  // const dotsNode = emblaCardsContributors.querySelector(".embla__dots");
  const embla = Embla(emblaCardsContributors, {
    slidesToScroll: "auto",
    containScroll: "trimSnaps",
  });

  const prevBtn = emblaCardsContributors.querySelector(".embla__button--prev-mob");
  const nextBtn = emblaCardsContributors.querySelector(".embla__button--next-mob");

  setupPrevNextBtns(prevBtn, nextBtn, embla);

  const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
  embla.on("select", disablePrevAndNextBtns);
  embla.on("init", disablePrevAndNextBtns);
}

if (emblaCardsArticles) {
  const embla = Embla(emblaCardsArticles, {
    slidesToScroll: "auto",
    containScroll: "trimSnaps",
  });

  const prevBtn = emblaCardsArticles.querySelector(".embla__button--prev-mob");
  const nextBtn = emblaCardsArticles.querySelector(".embla__button--next-mob");

  setupPrevNextBtns(prevBtn, nextBtn, embla);

  const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
  embla.on("select", disablePrevAndNextBtns);
  embla.on("init", disablePrevAndNextBtns);
}

if (viewportNodeMainCarousel && viewportNodeThumbCarousel) {
  const emblaApiMain = Embla(viewportNodeMainCarousel, OPTIONS);
  const emblaApiThumb = Embla(viewportNodeThumbCarousel, OPTIONS_THUMBS);

  const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
    emblaApiMain,
    emblaApiThumb
  );
  const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
    emblaApiMain,
    emblaApiThumb
  );

  emblaApiMain
    .on("destroy", removeThumbBtnsClickHandlers)
    .on("destroy", removeToggleThumbBtnsActive);

  emblaApiThumb
    .on("destroy", removeThumbBtnsClickHandlers)
    .on("destroy", removeToggleThumbBtnsActive);
}

export default {};
